import React from "react";
import { createPortal } from "react-dom";
import { ErrorBoundary } from "@jsq/ds/core";
import { camelCaseKeys } from "common/utils/objectUtils";
import registeredPillars from "./pillar-registry";
import { ErrorMessage } from "./ErrorMessage";

export type PillarProps = {
  name: string;
  node: HTMLElement;
  props: Record<string, string> | null;
};

/**
 * Given a pillar name, node and props, this component will render the pillar in a
 * react portal into the node
 */
export const Pillar = React.memo(({ name, node, props }: PillarProps) => {
  const RegisteredPillar = registeredPillars[name];

  // turn props keys to camel case for convenience
  const camelCaseProps = props ? camelCaseKeys(props) : props;

  // eslint-disable-next-line no-param-reassign
  node.style.display = "";

  return (
    <>
      {createPortal(
        <ErrorBoundary additionalTags={{ pillarCrash: name }} fallback={<ErrorMessage />}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <RegisteredPillar {...camelCaseProps} />
        </ErrorBoundary>,
        node,
        name,
      )}
    </>
  );
});
